const actionTypeIdentifier = "EB7E62C5-B8AF-4F78-9BFF-50D4C09E5D19";

export const setContractHistoryLogsLoading = `SET-CONTRACT-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getContractHistoryLogs = `GET-CONTRACT-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setContractHistoryPageSize = `SET-CONTRACT-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetContractHistory = `RESET-CONTRACT-HISTORY-${actionTypeIdentifier}`;
export const setContractHistoryColSearchStr = `SET-CONTRACT-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
